import PasswordPolicy from "newApp/entities/PasswordPolicy";
import SettingsLocks from "newApp/entities/SettingsLocks";

export default class Settings {
    constructor (json) {
        this.organizationId = 0;
        this.webTimeout = 30;
        this.settingsLocks = {};

        this.accountLockoutPolicy = {
            threshold: 5,
            interval: 15
        };

        this.passwordPolicy = new PasswordPolicy();
        this.settingsLocks = new SettingsLocks();

        if (json)
            mapJsonToSettings(json, this);
    }

    toJson () {
        var json = {};
        mapSettingsToJson(this, json);
        return json;
    }


    createCopy () {
        const settings = new Settings();
        settings.organizationId = this.organizationId;
        settings.webTimeout = this.webTimeout;
        settings.settingsLocks = this.settingsLocks.createCopy();
        settings.accountLockoutPolicy = Object.assign({}, this.accountLockoutPolicy);
        settings.passwordPolicy = this.passwordPolicy.createCopy();
        return settings;
    }
    static createValidationObject () {
        return {
            maximumAge: {
                rangeRule: {
                    isValid: true
                }
            },
            minimumLength: {
                sumOfFieldsRule: {
                    isValid: true
                },
                rangeRule: {
                    isValid: true
                }
            },
            alphabeticalCharacters: {
                sumOfFieldsRule: {
                    isValid: true
                },
                minimumPasswordLengthRule: {
                    isValid: true
                }
            },
            uppercaseCharacters: {
                minimumAlphabeticalCharactersLengthRule: {
                    isValid: true
                }
            },
            lowercaseCharacters: {
                minimumAlphabeticalCharactersLengthRule: {
                    isValid: true
                }
            },
            numericCharacters: {
                minimumPasswordLengthRule: {
                    isValid: true
                }
            },
            punctuationOrOtherCharacters: {
                minimumPasswordLengthRule: {
                    isValid: true
                }
            }
        };

    }
}

const mapJsonToSettings = (json, settings) => {
    settings.webTimeout = json.WebTimeout;
    settings.organizationId = json.OrgId;

    settings.threshold = json.LockoutMaxBadPasswordAttempts;
    settings.interval = json.LockoutIntervalMinutes;

    settings.passwordPolicy = new PasswordPolicy(json);

    settings.accountLockoutPolicy.interval = json.LockoutIntervalMinutes;
    settings.accountLockoutPolicy.threshold = json.LockoutMaxBadPasswordAttempts;

    settings.settingsLocks = new SettingsLocks(json.OrganizationSettingsLock);
};

const mapSettingsToJson = (settings, json) => {
    json.OrgId = settings.organizationId;
    json.WebTimeout = settings.webTimeout;

    // Account lockout policy settings
    json.LockoutMaxBadPasswordAttempts = settings.accountLockoutPolicy.threshold;
    json.LockoutIntervalMinutes = settings.accountLockoutPolicy.interval;

    // Password policy settings
    json.PasswordValidDays = settings.passwordPolicy.maximumAge;
    json.MinimumPasswordLength = settings.passwordPolicy.minimumLength;
    json.RequiredAlphabeticalLetters = settings.passwordPolicy.alphabeticalCharacters.number;
    json.RequiredCapitalLetters = settings.passwordPolicy.alphabeticalCharacters.uppercaseCharacters.number;
    json.RequiredLowercaseLetters = settings.passwordPolicy.alphabeticalCharacters.lowercaseCharacters.number;
    json.RequiredNumerals = settings.passwordPolicy.numericCharacters.number;
    json.RequiredPunctuationOrOther = settings.passwordPolicy.punctuationOrOtherCharacters.number;
};

